// Libraries
import React from 'react';
import ReactDOM from 'react-dom';
import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider} from '@mui/material/styles';

// Assets
import './assets/css/global.css';
import './assets/css/scrollbar.css';

// Layouts
import { Index as AdministratorCore } from './__administrator';

const pageTheme = createTheme({
    palette: {
        background: {
            default: '#F4F6F6'
        },
		primary: {
			main: '#003539',
			dark: '#1c474a',
			light: '#F5F9F9',
			// light: '#F4F6F6'
			accredmain: '#007D81',
			accreddark: '#004E54',
			accredlight: '#04949F'
		},
		secondary: {
			main: '#04949F',
			dark: '#04757E',
			light: '#ffffff',
		},
		info: {
			main: '#7aa3a1',
			dark: '#506e6c',
			light: '#b8d4d2',
		},
		error: {
			main: '#f44336',
			light: '#f6685e',
			dark: '#d32f2f'
		},
		warning: {
			main: '#ff9800',
			dark: '#b26a00',
			light: '#ffac33'
		},
		success: {
			main: '#4caf50',
			// main: '#00BE81',
			dark: '#388e3c',
			light: '#81c784'
		},
		btnYellow:{
			light: '#ffcd87',
			main: '#ffb347',
			color: '#f2f5fa'
		},
		accrediteePrimary: {
			main: '#007D81',
			dark: '#004E54',
			light: '#04949F'
		}
    },
    typography: {
		button: {
			textTransform: 'none'
		},
		fontFamily: [
		  '-apple-system',
		  '"Poppins"',
		].join(','),
	},
});

const Core = AdministratorCore

// if (loc[2] === 'administrator') {
// 	Core = AdministratorCore
// } else {
// 	Core = FacilityCore
// }

ReactDOM.render(<ThemeProvider theme= { pageTheme }><CssBaseline /><Core /></ThemeProvider>, document.getElementById('root'));